<div class="sidenav-content" [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller"
	copoAfterViewInit (afterviewinit)="scroller.restoreState();">
	<ng-container *ngIf="!isOffline; else offline">
		<copo-survey *ngIf="user.hasServiceParameterEqualsTo('PSRVY','OrderDelivery', 'True')"
		[screenCode]="wotOverview"></copo-survey>
		<div class="card-title-block-non-sticky">
			<div class="card-title-label" translate>delivery-tracking.order-and-delivery-overview</div>
		</div>
		<div class="copo-container grid-6 footer-margin">
			<copo-information-on-delivery-date *ngIf="user.hasServiceParameterEqualsTo('PORDT','INDND', 'False') else newDesign" class="card-block grid-column-two-third"></copo-information-on-delivery-date>
			<copo-delivery-follow-up class="card-block grid-column-one-third"></copo-delivery-follow-up>
			<copo-mills-stock-materials class="card-block grid-column-one-third"></copo-mills-stock-materials>
			<copo-available-batches class="card-block grid-column-two-third"></copo-available-batches>
		</div>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #newDesign>
		<copo-information-on-delivery-date-new-design class="card-block grid-column-two-third"></copo-information-on-delivery-date-new-design>
	</ng-template>
</div>
